import { useTranslation } from 'react-i18next';
import { Center, Spinner } from 'src/components/atoms';
import { LoadingContainer, StyledText } from './OPRLoadingPage.styles';
import theme from 'src/theme/theme';
import { CustomHeaderContainer } from '../OpenReportingContainer/OpenReportingContainer.styles';
import CustomHeader from '../CustomHeader';
import { Footer } from 'src/components/moleculesLegacy/Footer';
import { SubmitSuccessContainer } from '../SubmitSuccess.styles';
interface Props {
  organisation: string;
}

export const OPRLoadingPage = (props: Props) => {
  const { t } = useTranslation();
  return (
    <SubmitSuccessContainer>
      <CustomHeaderContainer>
        <CustomHeader organisation={props.organisation} hideID />
      </CustomHeaderContainer>
      <Center>
        <LoadingContainer>
          <Spinner
            variant="custom"
            size="xlarge"
            colors={[
              theme.newPalette.neutral.N0,
              theme.newPalette.neutral.N800,
            ]}
          />
          <StyledText>{t('public.Loading.loading')}</StyledText>
        </LoadingContainer>
      </Center>
      <Footer id="desktop-powered-by-vault" />
    </SubmitSuccessContainer>
  );
};
